import eventBus from 'general/js/event-bus';

const FAVOURITE_PLAYERS_STORAGE_KEY = 'favouritePlayers';

export const EVENT_FAVOURITE_PLAYER_SERVICE_ADD = 'EVENT_FAVOURITE_PLAYER_SERVECE_ADD';
export const EVENT_FAVOURITE_PLAYER_SERVICE_REMOVE = 'EVENT_FAVOURITE_PLAYER_SERVECE_REMOVE';

class FavoritePlayerServices {
    constructor() {
        this.state = {
            favoritePlayers: []
        };

        this.init();
    }

    init() {
        this.state.favoritePlayers = this._getDataFromLocalStorage();
    }

    add(id) {
        if (typeof id !== 'string') return;

        if (!this.isFavourite(id)) {
            this.state.favoritePlayers = [...this.state.favoritePlayers, id];
        }

        this._setDataToLocalStorage();
        eventBus.emit(EVENT_FAVOURITE_PLAYER_SERVICE_ADD, { playerId: id });
    }

    remove(id) {
        this.state.favoritePlayers = this.state.favoritePlayers.filter((favoritePlayerId) =>
            favoritePlayerId !== id);
        this._setDataToLocalStorage();
        eventBus.emit(EVENT_FAVOURITE_PLAYER_SERVICE_REMOVE, { playerId: id });
    }

    getAll() {
        return this.state.favoritePlayers;
    }

    isFavourite(id) {
        return this.state.favoritePlayers.includes(id.toString());
    }

    _setDataToLocalStorage = () => {
        window.localStorage.setItem(
            FAVOURITE_PLAYERS_STORAGE_KEY,
            JSON.stringify(this.state.favoritePlayers)
        );
    };

    _getDataFromLocalStorage = () => {
        let data;

        try {
            data = JSON.parse(window.localStorage.getItem(FAVOURITE_PLAYERS_STORAGE_KEY));
        } catch (error) {
            console.log(error.message);
        }

        return Array.isArray(data) ? data : [];
    };
}

const instance = new FavoritePlayerServices();
export default instance;
